import { animate, AUTO_STYLE, style, transition, trigger } from '@angular/animations';
import {
    AfterViewInit,
    Component,
    ElementRef,
    HostBinding,
    Inject,
    OnInit,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import deLocale from '@fullcalendar/core/locales/de';
import esLocale from '@fullcalendar/core/locales/es';
import frLocale from '@fullcalendar/core/locales/fr';
import { AppointmentConfigurationComponent } from './../appointment-configuration/appointment-configuration.component';
import {appointmentCard, whiteButton, whiteButtonActive, whiteButtonLast, whiteButtonLastActive} from "../../../theme";
import { APP_BASE_HREF, DatePipe, PlatformLocation } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FullCalendarComponent } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // a plugin
import { Apollo, gql, QueryRef } from 'apollo-angular';
import { Calendar, CalendarApplicationComponent, CalendarEvent, ConferenceInput, CoreLibService, Mutation, Query, Location, CalendarEventFeedbackStatus, CalendarEventFeedbackInput, LinkOpenMode } from 'core-lib';
import { PaymentBookingRequest, PaymentIntent, PaymentIntentPosition, PaymentLibComponent } from 'payment-lib';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'projects/appointment-module/src/environments/environment';
import { MemberListVisibility } from 'projects/core-lib/src/projects';
import { from, Subscription } from 'rxjs';
import { concatAll, toArray } from 'rxjs/operators';
import { AppointmentFilterSettingsComponent } from '../appointment-filter-settings/appointment-filter-settings.component';
import { AppointmentManagementEditComponent } from '../appointment-management-edit/appointment-management-edit.component';
import { EventRegistrationComponent } from '../event-registration/event-registration.component';
import { Message } from 'primeng/message';

import  moment from 'moment';

@Component({
    selector: 'lib-appointment-management-list',
    templateUrl: './appointment-management-list.component.html',
    styleUrls: ['./appointment-management-list.component.scss'],
    providers: [{ provide: APP_BASE_HREF, useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(), deps: [PlatformLocation] }],
    animations: [
        trigger('collapse', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate('200ms ease-out', style({ height: AUTO_STYLE, opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: AUTO_STYLE, opacity: 1 }),
                animate('200ms ease-in', style({ height: 0, opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class AppointmentManagementListComponent implements OnInit, AfterViewInit {
  @HostBinding('attr.component') componentAttribute :string = "";
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  @ViewChild('scrollable') scrollableArea: ElementRef;
  @ViewChild('scrollHeader') scrollHeader: ElementRef;
  apiURL = environment.apiURL;
  moment = moment;
    protected readonly whiteButton = whiteButton;
    protected readonly whiteButtonActive = whiteButtonActive;
    protected readonly whiteButtonLast = whiteButtonLast;
    protected readonly whiteButtonLastActive = whiteButtonLastActive;

  headerRendererTimeout: any = null;
  scrollIntoViewTimeout: any = null;
  scrollIntoViewCompleted = false;
  appointmentDeadLines: { String?: Date } = {};
  appointmentStartOfRegistrations: { String?: Date } = {};

  appointments: CalendarEvent[] = [];
  appointmentsForCalendar: EventInput[] = [];
  allCategories = [];

  calendars: Calendar[] = [];
  selectedCalendarIds: string[] = [];
  selectedLocationIds: string[] = [];
  lastAccess: Date;

   buttonLabels = {
    openFilterOptionDialogFilterActive: $localize`:@@appointment-management-list.buttons.openFilterOptionDialogFilterActive:Open filter options dialog. No filters currently applied.`,
    openFilterOptionDialogNoFilter: $localize`:@@appointment-management-list.buttons.openFilterOptionDialogNoFilter:Open filter options dialog. At least one filter is currently applied.`,
    calendarView: $localize`:@@appointment-management-list.buttons.calendarViewActive:Switch to calendar view. Note: The displayed content is not optimized for screen readers`,
    listView: $localize`:@@appointment-management-list.buttons.listView:Switch to list view`,
    addToFavorites: $localize`:@@appointment-management-list.buttons.addToFavorites:Add appointment to favorites`,
    removeFromFavorites: $localize`:@@appointment-management-list.buttons.removeFromFavorites:Remove appointment from favorites`,
    participantFeedbackThumbUpActive: $localize`:@@appointment-management-list.buttons.participantFeedbackThumbUpActive:Participation feedback thumbs-up active`,
    participantFeedbackThumbUpInactive: $localize`:@@appointment-management-list.buttons.participantFeedbackThumbUpInactive:Participation feedback thumbs-up inactive`,
    participantFeedbackThumbDownActive: $localize`:@@appointment-management-list.buttons.participantFeedbackThumbDownActive:Participation feedback thumbs-down active`,
    participantFeedbackThumbDownInactive: $localize`:@@appointment-management-list.buttons.rparticipantFeedbackThumbDownInactive:Participation feedback thumbs-down inactive`,
    participantFeedbackMaybeActive: $localize`:@@appointment-management-list.buttons.participantFeedbackMaybeActive:Participation feedback maybe active`,
    participantFeedbackMaybeInactive: $localize`:@@appointment-management-list.buttons.participantFeedbackMaybeInactive:Participation feedback maybe inactive`,
  }


  calendarsMap: Map<String, Calendar> = new Map();
  dialogControl = {
    context: null, showAppointmentDetailsPopup: false, showAppointmentSignUpOverview: false, showEventReminder: false, corruptFilter: false, feedbackDialog: {
      visible: false,
      comment: null,
      status: CalendarEventFeedbackStatus.Negative,
      event: null
    }
  };
  appointmentListControl: { string?: { collapsed: boolean, eventRegistrationCollapsed: boolean, ownRegistrationsPayed: true } } = {};
  calendarViewActive = false;
  filterRange: { start?: Date, end?: Date, value?: string, format?: string, page?: any };
  filterMyEvents = false;
  filterOnlyWithFreeSignUpSlots = false;
    dontFilterUpcomingEvents = false;
    onlyShowFavorites = false;
  searchText: any;
  preSelectedAppointment: string;
  loading = true;
  isAdmin = false;
  dontSaveFilter = false;
  hasUrlCalendarIds: boolean = false;

  eventsToGiveFeedback: CalendarEvent[] = [];
  queryParameters = {
    calendarIds: [],
    locationIds: [],
    range: { from: Date, to: Date },
  } as any;
  private loadEventsQuerySubscription: Subscription;
  private loadEventsQueryRef: QueryRef<Query>;

  displayCreateCategoryForm: boolean;
  displayCategoryManagement: boolean;

  displayCardView: boolean;
  displayCardViewState: any;
  availableLocations: Location[] = [];

  @ViewChildren(EventRegistrationComponent)
  eventRegistrationComponent: EventRegistrationComponent[];
  feedbackType = CalendarEventFeedbackStatus;
  favoritesArray: String[] = [];

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin,
      interactionPlugin],
    height: '100%',
    headerToolbar: {
      left: 'today',
      center: '',
      right: 'dayGridDay,dayGridWeek,dayGridMonth'
    },

    footerToolbar: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    firstDay: 1,
    weekNumbers: false,
    weekText: '',
    eventTimeFormat: { // like '14:30:00'
      hour: '2-digit',
      minute: '2-digit',
      meridiem: false
    },
    locales: [deLocale, frLocale, esLocale],
    locale: $localize.locale,
    datesSet: (e) => {
      const cStart: Date = e.start;
      const cEnd: Date = e.end;
      this.loadEventsQueryRef.refetch({
        calendarIds: this.selectedCalendarIds,
        range: { from: cStart, to: cEnd }
      });
    },
    dateClick: (e: any) => {
      this.calendarComponent.getApi().changeView('dayGridDay', e.dateStr);
    },
    eventClick: (info) => {
      const id = info.event.id;
      this.onToggleAppointmentDetail(this.appointments.find((app) => app.id === id), true);
    },
    events: []
  };

  public static CALENDAR_EVENT_FIELDS = `id
  calendarId
  seriesId
  title
  subTitle
  description
  detailLink
  dateStart
  dateTimeStart
  dateEnd
  dateTimeEnd
  categories {
    id
    title
    color
  }
  registrationRequired
  allDay
  maxSignUps
  minSignUps
  multiSignUpAllowed
  maxAdditionalSignUps
  registrationCount
  requestCount
  iconImage {
    id
    url
  }
  location {
    id
    geoLat
    geoLng
    title
    postalCode
    street
    city
  }
  resources {
    id
    url
  }
  seats
  ownerId
  onlineConference
  paymentDocumentation
  registrationFormId
  products{
    id
    name
  }
  deadlineStartOffsetMinutes
  startOfRegistrationOffsetMinutes
  cancelRegistrationDeadlineOffsetMinutes
  notifyEventContactPersonOnSignUp
  issueTicketsUponRegistration
  memberListVisibility
  manageAttendees
  publicRegistrationAllowed
  waitingListEnabled
  maxReservationTime
  badgeEnabled
  lastModificationDate
  contactGroupId
  contactId
  contact{
    id
    realname
  }
  canWrite
  reminder{
    active
    message
    value
  }
  feedbackAllowed
  ownFeedback{
    status
    comment
  }
  `;

  LOAD_CALENDAR_EVENTS_QUERY = gql`
  query findCalendarEvents($calendarIds: [ID]!,$range : DateRange,$locationIds: [ID],$search: String){
    findCalendarEvents(calendarIds: $calendarIds,range : $range,locationIds:$locationIds, search: $search) {
      ${AppointmentManagementListComponent.CALENDAR_EVENT_FIELDS}
    }
    listOwnCalendarEventRegistrations(calendarIds: $calendarIds, range : $range){
      id
      comment
      calendarEventId
      status
      payed
      waitingPosition
      seat{
        id
        userProfileId
        name
        firstname
        phoneNumber
        email
        comment
      }
    }
  }`;


  INIT_QUERY = gql`
  query combinedInitQuery($componentId:ID!, $from: Date!, $to: Date!,$componentIdParam:String){
    getDevicePushNotifications(from: $from, to: $to,componentId:$componentIdParam){
      id
      message
      dispatchDate
    }
    listCalendarByComponentId(componentId: $componentId) {
      id
      title
      color
      canWrite
      canRead
      readerRoles{
        value
      }
      writerRoles{
        value
      }
      ownedByGroupId
    }
    applicationComponent(id:$componentId){
      applicationType
      ... on CalendarApplicationComponent{
        config
      }
    }
    listLocations{
      id
      title
      postalCode
      street
      city
      geoLat
      geoLng
    },
  }`;

  private loadGetSignUpsForEventRef: QueryRef<Query>;

  QUERY_GET_CURRENT_EVENT = gql`
  query getCalendarEventById($calendarEventId: ID!){
    getCalendarEventById(calendarEventId: $calendarEventId) {
     ${AppointmentManagementListComponent.CALENDAR_EVENT_FIELDS}
      ownRegistrations {
        id
        comment
        status
        payed
        waitingPosition
        seat{
          id
          userProfileId
          name
          firstname
          phoneNumber
          email
          comment
        }
      }
  }}`;

  QUERY_JOIN_CONFERENCE = gql`
  query joinConference($input: ConferenceInput!){
    joinConference(input: $input) {
      url
      guestUrl
      room
  }}`;

  MUTATION_CONFIRM_EVENT_PAYMENT = gql`
  mutation confirmEventPayment($registrationId : ID!,$ticketId: ID){
    confirmEventPayment(registrationId : $registrationId,ticketId: $ticketId){
      payed
      id
  }}`;

  MUTATION_SEND_FEEDBACK = gql`
  mutation createEventFeedback($eventId: ID!, $feedback: CalendarEventFeedbackInput!){
    createEventFeedback(eventId : $eventId,feedback: $feedback){
      id
      status
      comment
  }}`;


  constructor(private dialogService: DialogService, private apolloClient: Apollo,
    @Inject('component') private component: string,
    public coreLibService: CoreLibService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private messageService: MessageService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
        this.componentAttribute = this.component;
  }




  isStartOfRegistrationReached(appointment: CalendarEvent): boolean {
    if (appointment.startOfRegistrationOffsetMinutes) {
      return moment().isAfter(moment(appointment.dateStart).subtract('minutes', appointment.startOfRegistrationOffsetMinutes));
    }
    return true;
  }

  /**
   * handle scrolling stuff
   */
  ngAfterViewInit(): void {
    const observer = new IntersectionObserver((el: IntersectionObserverEntry[]) => {
      const elx = el[0];
      if (elx.isIntersecting) {
        if (elx.target.getBoundingClientRect().top < document.body.clientHeight / 2) {
          const id = elx.target.getAttribute("id");
          if (id == null) {
            return;
          }
          const event = this.appointments.find((event) => event.id === id);
          if (this.scrollIntoViewCompleted == true) {
            this.renderScrollHeader(event);
          }
        }
      }
    }, {
      root: this.scrollableArea.nativeElement,
      threshold: [0.1, 1.0],
    });
    new MutationObserver((ev: MutationRecord[]) => {
      ev.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          observer.observe(node as Element);
          if (this.scrollIntoViewCompleted == false) {
            clearTimeout(this.scrollIntoViewTimeout);
            this.scrollIntoViewTimeout = setTimeout(() => { this.scrollFirstItemIntoView() }, 200);
          }
        });
        record.removedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          observer.unobserve(node as Element);
        })
      })
    }).observe(this.scrollableArea.nativeElement, { childList: true });
  }

  scrollFirstItemIntoView(): void {
    if (this.appointments) {
      let nextAppointment = this.appointments.find((event) => {
        if (new Date(event.dateStart).getTime() > new Date().getTime() || new Date(event.dateEnd).getTime() > new Date().getTime()) {
          return true;
        }
        return false;
      });
      if (this.preSelectedAppointment) {
        nextAppointment = this.appointments.find((app) => app.id === this.preSelectedAppointment);
        this.onToggleAppointmentDetail(nextAppointment, false)
      }

      if (nextAppointment) {
        let el = document.getElementById(nextAppointment.id).querySelector('.appointment-card') as HTMLElement;
        let offsetTop = el.offsetTop;

        this.scrollableArea.nativeElement.scroll({
          top: offsetTop,
          left: 0,
          behavior: 'smooth'
        })
        const scrollContent = this.scrollableArea.nativeElement;
        let indexOfNextAppointment = this.appointments.indexOf(nextAppointment)
        // falls die Seite scrollbar ist oder es kein Element davor gibt
        if (scrollContent.scrollHeight > scrollContent.clientHeight || this.appointments[indexOfNextAppointment - 1] === undefined) {
          this.renderScrollHeader(nextAppointment);
          setTimeout(() => {
            this.scrollIntoViewCompleted = true;
          }, 200);
        }
        // falls nicht
        else {
          this.renderScrollHeader(this.appointments[indexOfNextAppointment - 1]);
          setTimeout(() => {
            this.scrollIntoViewCompleted = true;
          }, 200);
        }
      }
    }
  }

  renderScrollHeader(event: CalendarEvent): void {
    if (event == null) {
      this.scrollHeader.nativeElement.innerHTML = "";
      return;
    }
    clearTimeout(this.headerRendererTimeout);
    this.headerRendererTimeout = setTimeout(() => {
      this.scrollHeader.nativeElement.innerHTML = this.datePipe.transform(new Date(event.dateStart), 'MMMM');
    }, 100)
  }

  showMemberListButton(event: CalendarEvent): boolean {
    if (event.registrationRequired == false && event.feedbackAllowed == false) {
      return false;
    }
    if (this.hasEventWritePermission(event)) {
      return true;
    }

    if (event.memberListVisibility === MemberListVisibility.Members) {
      if (event.ownRegistrations && event.ownRegistrations.length > 0) {
        return true;
      }
    }

    if (event.memberListVisibility === MemberListVisibility.Profile) {
      if (this.coreLibService.getSecurityInformation().userProfile != null) {
        return true
      }
    }
    return false;
  }

  showBadge(event: CalendarEvent): boolean {
    if (event.badgeEnabled && event.lastModificationDate && this.lastAccess) {
      if (moment(event.lastModificationDate).isAfter(this.lastAccess)) {
        return true;
      }
    }
    return false;
  }

  ngOnInit(): void {
    this.isAdmin = this.coreLibService.hasAnyClaims(['component_update']);

    let favoritesString: string = localStorage.getItem(`state_${this.component}_favorites`);
    if(favoritesString){
        let localFavoritesArray = JSON.parse(favoritesString);
        if(Array.isArray(localFavoritesArray)){
            this.favoritesArray = localFavoritesArray
        }
        else{
            this.favoritesArray = [];
        }
    }

    const lastAccessStorageKey = `state_${this.component}_lastAccess`;
    const lastAccessString = localStorage.getItem(lastAccessStorageKey);
    if (lastAccessString) {
      this.lastAccess = new Date(lastAccessString);
    } else {
      this.lastAccess = new Date();
    }
    localStorage.setItem(lastAccessStorageKey, new Date().toISOString());


    this.apolloClient.query<Query>({
      query: this.INIT_QUERY,
      variables: {
        componentId: this.component,
        from: moment().subtract(1, 'hours').toDate(),
        to: moment().toDate(),
        componentIdParam: this.component
      }
    }).subscribe((result) => {
      this.calendars = result.data.listCalendarByComponentId.filter(c => c.canRead);
      this.availableLocations = result.data.listLocations;

      const reminderPushNotifications = result.data.getDevicePushNotifications;
      if (reminderPushNotifications.length > 0) {
        const lastPushidKey = `event_last_reminder_push_showed`;
        const pushShowed = localStorage.getItem(lastPushidKey) != null && localStorage.getItem(lastPushidKey) == reminderPushNotifications[0].id;
        if (!pushShowed) {
          this.dialogControl.context = reminderPushNotifications[0];
          this.dialogControl.showEventReminder = true;
          localStorage.setItem(lastPushidKey, reminderPushNotifications[0].id);
        }
      }

      const persistentFilterString = localStorage.getItem(`state_${this.component}_filter`);
      let persistentFilter: any = null;
      if (persistentFilterString) {
        persistentFilter = JSON.parse(persistentFilterString);
        this.filterMyEvents = persistentFilter.filterMyEvents;
        this.dontFilterUpcomingEvents = persistentFilter.dontFilterUpcomingEvents;
        this.onlyShowFavorites = persistentFilter.onlyShowFavorites;
        this.filterOnlyWithFreeSignUpSlots = persistentFilter.filterOnlyWithFreeSignUpSlots;
        this.selectedLocationIds = persistentFilter.selectedLocationIds;

        if (this.selectedLocationIds.some(locationId => this.availableLocations.find(location => location.id === locationId) == undefined)) {
          this.dialogControl.corruptFilter = true;
        }
      }

      this.selectedCalendarIds = this.calendars.map(calendar => calendar.id);

      this.calendarsMap.clear();
      this.calendars.forEach((calendar) => { this.calendarsMap.set(calendar.id, calendar) });

      const applicationComponent: CalendarApplicationComponent = result.data.applicationComponent;
      if (applicationComponent) {
        const config = applicationComponent.config;
        if (config && config['period_shown']) {
          const periodConfiguration = AppointmentConfigurationComponent.PERIOD_BY_VALUE(config['period_shown']);

          this.filterRange = JSON.parse(JSON.stringify(periodConfiguration));
          this.filterRange.page = periodConfiguration.page.clone();
        }
      }
      if (!this.filterRange) {
        this.filterRange = AppointmentConfigurationComponent.PERIOD_BY_VALUE('3M');
      }
      const queryParams = this.route.snapshot.queryParamMap;
      if (queryParams) {
        const startParam = queryParams.get('start');
        const endParam = queryParams.get('end');
        const appointmentParam = queryParams.get('event');
        if (startParam && endParam) {
          this.filterRange.start = moment(startParam, 'YYYY-MM-DD').toDate();
          this.filterRange.end = moment(endParam, 'YYYY-MM-DD').endOf('day').toDate();
        }
        this.preSelectedAppointment = appointmentParam;
      }
      this.queryParameters = {
        calendarIds: this.selectedCalendarIds,
        locationIds: this.selectedLocationIds,
        range: { from: this.filterRange.start, to: this.filterRange.end },
      } as any;

      this.route.queryParamMap.subscribe(params => {
        const viewMode = params.get("viewMode");
        if (viewMode && viewMode === 'calendar') {
          this.calendarViewActive = true;
        }
        const filterText = params.get("filterText");
        if (filterText && filterText !== '') {
          this.searchText = filterText;
          this.queryParameters.search = filterText;
        }
        const calendarIds = params.get("calendarIds");
        if (calendarIds && calendarIds !== '') {
          this.hasUrlCalendarIds = true;
          const cids = calendarIds.split(",");
          this.selectedCalendarIds = this.calendars.filter(c => cids.indexOf(c.id) > -1).map(calendar => calendar.id);
          this.queryParameters.calendarIds = this.selectedCalendarIds
        }
        const dontSaveFilter = params.get("dontSaveFilter");
        if (dontSaveFilter && dontSaveFilter == 'true') {
          this.dontSaveFilter = true;
        }
      });

      if (persistentFilter && persistentFilter.selectedCalendarIds) {
        // Prüfen, ob ein Kalendeer im Filter nicht mehr existiert.
        if (persistentFilter.selectedCalendarIds.some(id => this.selectedCalendarIds.indexOf(id) == -1)) {
          this.dialogControl.corruptFilter = true;
        }
        this.selectedCalendarIds = persistentFilter.selectedCalendarIds.filter((cid => this.selectedCalendarIds.indexOf(cid) > -1));
        this.queryParameters.calendarIds = this.selectedCalendarIds
      }


      this.loadEventsQueryRef = this.apolloClient.watchQuery<Query>({
        query: this.LOAD_CALENDAR_EVENTS_QUERY,
        variables: this.queryParameters,
        useInitialLoading: true
      });


      this.loadEventsQuerySubscription = this.loadEventsQueryRef.valueChanges.subscribe(({ data, loading }) => {
        if (loading) {
          return;
        }
        this.appointmentDeadLines = {};
        this.appointmentStartOfRegistrations = {};
        this.appointments = data.findCalendarEvents;
        const ownRegistrations = data.listOwnCalendarEventRegistrations;
        const ownRegistrationMap = {};
        if (ownRegistrations) {
          for (const eventRegistration of ownRegistrations) {
            if (ownRegistrationMap[eventRegistration.calendarEventId] == null) {
              ownRegistrationMap[eventRegistration.calendarEventId] = [];
            }
            ownRegistrationMap[eventRegistration.calendarEventId].push(eventRegistration);
          }
        }
        this.appointments.forEach((appointment: CalendarEvent) => {
          appointment.ownRegistrations = ownRegistrationMap[appointment.id];

          if (appointment.ownRegistrations == null) {
            appointment.ownRegistrations = [];
          }
          if (appointment.deadlineStartOffsetMinutes && appointment.registrationRequired) {
            this.appointmentDeadLines[appointment.id] = moment(appointment.dateStart).subtract('minutes', appointment.deadlineStartOffsetMinutes).toDate();
          }
          if (appointment.startOfRegistrationOffsetMinutes && appointment.registrationRequired) {
            this.appointmentStartOfRegistrations[appointment.id] = moment(appointment.dateStart).subtract('minutes', appointment.startOfRegistrationOffsetMinutes).toDate();
          }
        });

        if (this.filterMyEvents) {
          this.appointments = this.appointments.filter((event) => event.ownRegistrations != null && event.ownRegistrations.length > 0);
        }

        if (!this.dontFilterUpcomingEvents) {
          this.appointments = this.appointments.filter((event) => moment(event.dateEnd).isAfter(new Date()));
        }

        if (this.onlyShowFavorites) {
          this.appointments = this.appointments.filter((event) => this.isFavorite(event));
        }

        if (this.filterOnlyWithFreeSignUpSlots) {
          this.appointments = this.appointments.filter((event) => event.registrationCount != event.maxSignUps);
        }

        this.scrollableArea.nativeElement.scrollTop = 0;
        if (this.appointments.length > 0) {
          this.renderScrollHeader(this.appointments[0]);
        } else {
          this.renderScrollHeader(null);
        }
        this.appointmentsForCalendar = this.appointments.map((event) => {
          let endDate = moment(event.dateEnd);
          if (event.allDay) {
            endDate = moment(event.dateEnd).add(1, 'day');
          }
          return { title: event.title, start: moment(event.dateStart).toDate(), end: endDate.toDate(), allDay: event.allDay, id: event.id, backgroundColor: this.calendarsMap.get(event.calendarId).color } as EventInput;
        });
        this.calendarOptions.events = this.appointmentsForCalendar;
        this.loading = false;
        this.eventsToGiveFeedback = this.appointments.filter((appointment)=> appointment.ownFeedback!=null && appointment.ownFeedback.status === this.feedbackType.Pending);
      });
    });
  }

  allCalendarsSelected(persistentFilter): boolean {
    var allSelected = true;

    if (!this.hasUrlCalendarIds) {
      this.calendars.forEach(calendar => {
        if (persistentFilter.selectedCalendarIds.indexOf(calendar.id) < 0) {
          allSelected = false;
        }
      })
    } else {
      let visibleCalendars = this.calendars.filter(calendar => this.queryParameters.calendarIds.includes(calendar.id));

      visibleCalendars.forEach(calendar => {
        if (this.hasUrlCalendarIds) {
          if (persistentFilter.selectedCalendarIds.indexOf(calendar.id) < 0) {
            allSelected = false;

          }
        }
      })
    }

    return allSelected;
  }

  onPay(event: CalendarEvent): void {
    const paymentIntent: PaymentIntent = {
      productDefinitionIds: event.products.map(p => p.id),
      positions: event.ownRegistrations.filter((registration) => registration.payed == false).map((eventRegistration) => {
        const p: PaymentIntentPosition = {
          title: `${eventRegistration.seat.firstname} ${eventRegistration.seat.name}`, subtitle: eventRegistration.seat.email, id: eventRegistration.id
        }
        return p;
      }),
      successUrl: `${window.location.origin}${this.baseHref}booking-confirmation`,
      title: event.title,
      subtitle: `${this.datePipe.transform(new Date(event.dateStart), 'short')} - ${this.datePipe.transform(new Date(event.dateEnd), 'short')}`
    };

    PaymentLibComponent.initPaymentInDialog(this.dialogService, paymentIntent).onClose.subscribe((result: PaymentBookingRequest[]) => {
      if (result) {
        const observable = result.map((bookingRequest) => {
          return this.apolloClient.mutate<Mutation>({
            mutation: this.MUTATION_CONFIRM_EVENT_PAYMENT,
            variables: {
              registrationId: bookingRequest.id, ticketId: bookingRequest.walletElement
            }
          });
        });

        from(observable).pipe(concatAll(), toArray()).subscribe((result) => {
          const allCompleted = result.filter((r => r.errors)).length == 0;
          if (allCompleted) {
            this.messageService.add({ severity: 'success', summary: $localize`:@@appointment-management-list.booking-complete:Booking complete` });
          }
          this.reloadEventData(event);
        });

      }
    });
  }


  isAllRegistrationsConfirmed(appointment: CalendarEvent): boolean {
    return appointment.ownRegistrations.filter((registration) => registration.status === 'CONFIRMED').length == appointment.ownRegistrations.length;
  }

  isReserved(appointment: CalendarEvent): boolean {
    return appointment.ownRegistrations.filter((registration) => registration.status === 'RESERVED').length == appointment.ownRegistrations.length;
  }

  waitingLinePosition(appointment: CalendarEvent): number {
    const reg = appointment.ownRegistrations.filter((registration) => registration.status === 'QUEUED');
    if (reg.length == 0) {
      return 0;
    }
    return reg[0].waitingPosition;
  }

  ngOnDestroy(): void {
    this.loadEventsQuerySubscription.unsubscribe();
  }

  onCloneAppointment(event: CalendarEvent): void {
    const cloned = { ...event };
    cloned.id = null;
    cloned.seriesId = null;
    cloned.registrationCount = 0;
    this.dialogService.open(AppointmentManagementEditComponent, {
      data: {
        appointment: cloned,
        clonedAppointment: true
      },
      focusOnShow: false,
      modal: true,
      draggable: false,
      closable: true,
      closeAriaLabel:$localize`:@@appointment-management-edit.closeButton:Close`,
      focusTrap: true,
      header: $localize`:appointment-management-edit.clone:Clone appointment`,
      width: '90%',
    }).onClose.subscribe((result) => {
      this.scrollIntoViewCompleted = false;
      this.loading = true;
      this.loadEventsQueryRef.resetLastResults();
      this.loadEventsQueryRef.refetch();
    });
  }

  onEditAppointment(event: CalendarEvent): void {
    this.dialogService.open(AppointmentManagementEditComponent, {
      data: {
        appointment: event
      },
      header: $localize`:appointment-management-edit.edit:Edit appointment`,
      width: '90%',
      modal: true,
      draggable: false,
      closable: true,
      focusOnShow: false,
      closeAriaLabel:$localize`:@@appointment-management-edit.closeButton:Close`,
      focusTrap: true,
    }).onClose.subscribe((result) => {
      if (result) {
        this.loading = true;
        this.loadEventsQueryRef.resetLastResults();
        this.loadEventsQueryRef.refetch();
        setTimeout(() => {
          document.getElementById(event.id).querySelector('.appointment-card').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }, 200)
      }
    });
  }

  convertToPlain(html: string) {

    // Create a new div element
    var tempDivElement = document.createElement("div");

    // Set the HTML content with the given value
    tempDivElement.innerHTML = html;

    // Retrieve the text property of the element
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }


  /**
   * add event to smartphone calendar
   * @param appointment
   */
  onAddToCalendar(appointment: CalendarEvent): void {
    let address = ``;
    if (appointment.location) {
      if (appointment.location.title) {
        address += appointment.location.title;
      }
      let addressData = [];
      if (appointment.location.street) {
        addressData.push(appointment.location.street);
      }
      if (appointment.location.postalCode && appointment.location.city) {
        addressData.push(`${appointment.location.postalCode} ${appointment.location.city}`);
      } else {
        if (appointment.location.city) {
          addressData.push(appointment.location.city);
        }
        if (appointment.location.postalCode) {
          addressData.push(appointment.location.postalCode);
        }
      }

      if (addressData.length > 0) {
        address += `: ${addressData.join(',')}`;
      }
    }

    let description = appointment.description;
    if (description == null) {
      description = '';
    }
    description = this.convertToPlain(description)

    var jsonObject = {
      "title": appointment.title,
      "allDay": appointment.allDay,
      "start": moment(appointment.dateStart).format('DD.MM.YYYY HH:mm'),
      "startISO": moment(appointment.dateStart).toISOString(),
      "end": moment(appointment.dateEnd).format('DD.MM.YYYY HH:mm'),
      "endISO": moment(appointment.dateEnd).toISOString(),
      "snippet": description,
      "address": address
    };
    const base64Encoeded = this.utf8_to_b64(JSON.stringify(jsonObject));
    const link = `event://${base64Encoeded}`;
    location.href = link;
  }

  utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  onNewAppointment(): void {
    const data = {preselectedCalendarId: null};
    if (this.selectedCalendarIds && this.selectedCalendarIds.length == 1){
      data.preselectedCalendarId = this.selectedCalendarIds[0];
    }

    this.dialogService.open(AppointmentManagementEditComponent, {
      data: data,
      header: $localize`:appointment-management-edit.new:New appointment`,
      width: '90%',
      modal: true,
      draggable: false,
      closable: true,
      focusOnShow: false,
      closeAriaLabel:$localize`:@@appointment-management-edit.closeButton:Close`,
      focusTrap: true,
    }).onClose.subscribe(() => {
      this.loading = true;
      this.loadEventsQueryRef.resetLastResults();
      this.loadEventsQueryRef.refetch();
    });
  }

  /**
   * refetch events with curent vars
   */
  refetchEvents(): void {
    const query = {
      calendarIds: this.selectedCalendarIds,
      locationIds: this.selectedLocationIds,
      range: { from: this.filterRange.start, to: this.filterRange.end }
    };
    if (this.searchText != null && this.searchText !== '') {
      query['search'] = this.searchText;
    }
    this.loading = true;
    this.loadEventsQueryRef.setVariables(query);
    this.loadEventsQueryRef.resetLastResults();
    this.loadEventsQueryRef.refetch();
  }

  onChangedViewStyle(): void {
    if (!this.calendarViewActive) {
      this.scrollIntoViewCompleted = false;
      this.refetchEvents();
    }
  }
  /**
  * moves cursor in the past
  */
  onFilterRangeBack(): void {
    this.filterRange.start = moment(this.filterRange.start).subtract(this.filterRange.page).toDate();

    if (this.filterRange.value.includes("M") || this.filterRange.value.includes("Q")) {
      this.filterRange.end = moment(this.filterRange.end).subtract(this.filterRange.page).endOf('month').toDate();
    } else {
      this.filterRange.end = moment(this.filterRange.end).subtract(this.filterRange.page).toDate();
    }

    this.refetchEvents();
  }
  /**
   * moves cursor in the future
   */
  onFilterRangeNext(): void {
    this.filterRange.start = moment(this.filterRange.start).add(this.filterRange.page).toDate();

    if (this.filterRange.value.includes("M") || this.filterRange.value.includes("Q")) {
      this.filterRange.end = moment(this.filterRange.end).add(this.filterRange.page).endOf('month').toDate();
    } else {
      this.filterRange.end = moment(this.filterRange.end).add(this.filterRange.page).toDate();
    }

    this.refetchEvents();
  }
  /**
   * opens link on google maps
   * @param event
   * @param ce
   */
  onOpenGoogleMaps(event: any, ce: CalendarEvent): void {
    event.stopPropagation();
    event.preventDefault();

    if (this.coreLibService.isNativeIOS()) {
      this.coreLibService.openLink(`http://maps.apple.com/?ll=${ce.location.geoLat},${ce.location.geoLng}&dirflg=d&q=${ce.location.title}`, LinkOpenMode.External, null);
    } else {
      this.coreLibService.openLink(`https://www.google.com/maps/search/?api=1&query=${ce.location.geoLat},${ce.location.geoLng}`, LinkOpenMode.External, null);
    }
  }

  /**
   * opens signup details
   * @param ce
   */
  onOpenSignupDetails(ce: CalendarEvent): void {
    this.appointmentListControl[ce.id].eventRegistrationCollapsed = false;
  }

  /**
   * closes signup details
   * @param ce
   */
  onCloseSignupDetails(ce: CalendarEvent): void {
    this.appointmentListControl[ce.id].eventRegistrationCollapsed = true;
    this.reloadEventData(ce);
  }
  /**
   * closes appointment details
   * @param event
   * @param ca
   */
  onCloseAppointmentDetail(event: Event, ca: CalendarEvent): void {
    event.stopPropagation();
    event.preventDefault();
    if (this.appointmentListControl[ca.id]?.collapsed == false) {
      this.appointmentListControl[ca.id] = { collapsed: true, currentPagedImageIndex: 0, eventRegistrationCollapsed: true };
    }
  }
  /**
   * unser entered search
   * @param event
   */
  onSearchTextChanged(eventTarget: EventTarget): void {
    let target = eventTarget as HTMLInputElement;
    this.searchText = target.value;
    this.refetchEvents();
  }
  /**
   * opens appointment details
   * @param event
   * @param inPopup
   * @returns
   */
  onToggleAppointmentDetail(event: CalendarEvent, inPopup: boolean): void {
    if (this.appointmentListControl[event.id]?.collapsed == false) {
      this.appointmentListControl[event.id].collapsed = true;
      if (!inPopup) {
        setTimeout(() => {
            let elem = document.getElementById(event.id).getElementsByClassName("detailsButton").item(0).getElementsByTagName("button").item(0) as HTMLElement;
            elem?.focus();
        }, 20);
      }
      return;
    } else {
      if (!inPopup) {
        setTimeout(() => {
            let elem = document.getElementById(event.id).getElementsByClassName("buttonContainer").item(0).getElementsByTagName("button").item(0) as HTMLElement;
            elem?.focus();
        }, 20);
      }
    }
    if (inPopup) {
      this.dialogControl.context = event;
      this.dialogControl.showAppointmentDetailsPopup = true;
    }
    this.appointmentListControl[event.id] = { collapsed: false, currentPagedImageIndex: 0, eventRegistrationCollapsed: true };

  }

  /**
   * page images in detail view
   * @param appointment
   * @param event
   */
  onImagePagingatorChanged(appointment, event) {
    const newIndex = event.first;
    this.appointmentListControl[appointment.id].currentPagedImageIndex = newIndex;
  }

  onSelectedCalendarsChanged() {
    this.refetchEvents();
  }

  onClickCardView() {
    this.displayCardView = true;
  }

  onOpenMoreInformation(appointment: CalendarEvent): void {
    this.coreLibService.openLink(appointment.detailLink, LinkOpenMode.Stack, null);
  }

  reloadEventData(appointment: CalendarEvent) {
    this.loadGetSignUpsForEventRef = this.apolloClient.watchQuery<Query>({
      query: this.QUERY_GET_CURRENT_EVENT,
      variables: {
        calendarEventId: appointment.id
      }
    })

    this.loadGetSignUpsForEventRef.valueChanges.subscribe((result) => {
      appointment.registrationCount = result.data.getCalendarEventById.registrationCount;
      appointment.ownRegistrations = result.data.getCalendarEventById.ownRegistrations;
      appointment = result.data.getCalendarEventById;
      const index = this.appointments.findIndex((app) => app.id === appointment.id);
      if (index > -1) {
        this.appointments[index] = { ...appointment };
      }
    });
  }

  onToggleDisplaySignUpOverview(event: CalendarEvent) {
    this.dialogControl.showAppointmentDetailsPopup = false;
    this.dialogControl.context = {
      event: event,
      writePermission: this.hasEventWritePermission(event)
    }
    this.dialogControl.showAppointmentSignUpOverview = true;
  }

  onCloseEventSignUpsOverview(event: CalendarEvent) {
    this.reloadEventData(event);
  }

  onGotoNextPendingFeedbackEvent(event: any) {
    const appointment = this.eventsToGiveFeedback[0];
    this.onToggleAppointmentDetail(appointment,false)
    document.getElementById(appointment.id).querySelector('.appointment-card').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }

  onOpenFilterSettings(event: any) {
    // Wenn per url Parameter Kalender-Ids mitgeschickt werden, sollen auch nur diese (selectedCalendarIds) im Filter angezeigt werden
    var visibleCalendars: Calendar[];
    if (this.hasUrlCalendarIds) {
      visibleCalendars = this.calendars.filter(calendar => this.queryParameters.calendarIds.includes(calendar.id));
    }
    else {
      visibleCalendars = this.calendars;
    }
    this.dialogService.open(AppointmentFilterSettingsComponent, {
      data: {
        calendars: visibleCalendars,
        selectedLocationIds: this.selectedLocationIds,
        selectedCalendarIds: this.selectedCalendarIds,
        filterMyEvents: this.filterMyEvents,
          dontFilterUpcomingEvents: this.dontFilterUpcomingEvents,
          onlyShowFavorites: this.onlyShowFavorites,
        filterOnlyWithFreeSignUpSlots: this.filterOnlyWithFreeSignUpSlots,
        isFilterActive: this.isfilterActive(),
      },
      modal: true,
      draggable: false,
      closable: true,
      focusOnShow: false,
      closeAriaLabel:$localize`:@@appointment-management-settings.modal.closeButton:Close`,
      focusTrap: true,
      header: $localize`:appointment-management-settings.modal.header:Filters`,
      styleClass: 'w-11 md:w-8 lg:w-5',
    }).onClose.subscribe((result) => {
      if (result) {
        var persistentFilter = {
          selectedCalendarIds: result.selectedCalendarIds,
          selectedLocationIds: result.selectedLocationIds,
          filterMyEvents: result.filterMyEvents,
            dontFilterUpcomingEvents: result.dontFilterUpcomingEvents,
            onlyShowFavorites: result.onlyShowFavorites,
          filterOnlyWithFreeSignUpSlots: result.filterOnlyWithFreeSignUpSlots
        };
        if (persistentFilter.selectedCalendarIds && this.allCalendarsSelected(persistentFilter)) {
          persistentFilter.selectedCalendarIds = null;
        }

        // Wenn man vom Gruppn dashboard kommt, soll der Filter nicht gespeichert werden
        if (!this.dontSaveFilter) {
          localStorage.setItem(`state_${this.component}_filter`, JSON.stringify(persistentFilter));
        }

        this.selectedCalendarIds = result.selectedCalendarIds;
        this.selectedLocationIds = result.selectedLocationIds;
        this.filterMyEvents = result.filterMyEvents;
        this.filterOnlyWithFreeSignUpSlots = result.filterOnlyWithFreeSignUpSlots;
        this.dontFilterUpcomingEvents = result.dontFilterUpcomingEvents;
        this.onlyShowFavorites = result.onlyShowFavorites;
        this.refetchEvents();
      }
    });
  }


  /**
   * join the online conference
   * @param event
   */
  joinConference(event: CalendarEvent) {
    this.apolloClient.query<Query>({
      query: this.QUERY_JOIN_CONFERENCE,
      variables: {
        input: { room: event.title, id: event.id} as ConferenceInput
      }
    }).subscribe((result) => {
      if (!result.errors) {
        const conference = result.data.joinConference;
        const url = conference.url ? conference.url : conference.guestUrl;
        this.coreLibService.openLink(url, LinkOpenMode.External, null);
      }
    });
  }
  hasEventWritePermission(event: CalendarEvent): boolean {
    return event.canWrite;
  }
  /**
   *
   * @param calenderId check if user has write permission for calendar
   */
  hasWritePersmission(calendarId: String): boolean {
    const calendar = this.calendarsMap.get(calendarId);
    if (calendar == null) {
      return false;
    }
    return calendar.canWrite;
  }

  /**
   * has any writeable calendar
   * @returns
   */
  hasAnyWriteableCalender(): boolean {
    const queryParams: string[] = this.route.snapshot.queryParamMap.get('calendarIds')?.split(',');
    return this.calendars.filter(c => {
        if(queryParams && queryParams.length && !queryParams.includes(c.id)){
            return false;
        }
        if(c.canWrite){
            return true
        }
    }).length > 0;
  }

  isSameDay(start, end): boolean {
    return moment(start).isSame(moment(end), 'day');
  }
  isSameMonth(start, end): boolean {
    return moment(start).isSame(moment(end), 'month');
  }

  isInPast(end): boolean {
    return moment(end).isBefore(moment());
  }

  getSafeHtmlDescription(description: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  isShowPageEnd(): boolean {
    if (this.filterRange.page.asMonths() >= 1) {
      if (this.isSameMonth(this.filterRange.start, this.filterRange.end)) {
        return false;
      }
    } else if (this.filterRange.page.asDays() <= 1) {
      if (this.isSameDay(this.filterRange.start, this.filterRange.end)) {
        return false;
      }
    }

    return true;
  }

  onReminderDone(): void {
    this.dialogControl.showEventReminder = false;
    this.dialogControl.context = null;
  }


  // isInGroupSpaceCalendar(): boolean {
  //   /* wenn calendar ids per parameter mitgegeben wurden und in diesen ein Gruppenkalender ist,
  //        dann handelt es sich um die weiterleitung vom Gruppen-Modul und Filter werden nicht gespeichert siehe #47857 */
  //   let visibleCalendars = this.calendars.filter(calendar => this.selectedCalendarIds.includes(calendar.id));
  //   return this.hasUrlCalendarIds && visibleCalendars.find(calendar => calendar.ownedByGroupId && calendar.ownedByGroupId != "") != undefined;
  // }

  resetFilter(): void {
    localStorage.removeItem(`state_${this.component}_filter`);
    window.location.reload();
  }

  isfilterActive(): boolean {
    let localFilter = JSON.parse(localStorage.getItem(`state_${this.component}_filter`))
    // kein local storage heißt keine Filter gesetzt
    if (localFilter == null) {
      return false;
    }
    // wenn keine Kalender und keine Orte und keine zusätzlichen einstellungen gefiltert sind
    if ((localFilter.selectedCalendarIds == null || this.allCalendarsSelected(localFilter)) && (!localFilter.selectedLocationIds || localFilter.selectedLocationIds.length == 0) && !this.isAdditionalFiltersActive(localFilter)) {
      return false;
    }
    return true;
  }

  isAdditionalFiltersActive(localFilter): boolean {
    return localFilter.filterOnlyWithFreeSignUpSlots || localFilter.dontFilterUpcomingEvents || localFilter.filterMyEvents || localFilter.onlyShowFavorites;
  }

  /**
   * clicked feedback
   * @param event
   * @param feedbackType
   */
  onClickFeedback(event: CalendarEvent, feedbackType: CalendarEventFeedbackStatus): void {
    let component = this.eventRegistrationComponent.find((component) => component.event?.id === event.id);
    this.dialogControl.feedbackDialog.status = feedbackType;
    this.dialogControl.feedbackDialog.event = event;
    this.dialogControl.feedbackDialog.comment = event.ownFeedback?.comment;
    switch (feedbackType) {
      case CalendarEventFeedbackStatus.Positive: {
        if (event.registrationRequired) {
          component.addAttendee();
        } else {
          this.dialogControl.feedbackDialog.visible = true;
        }
        break;
      }
      case CalendarEventFeedbackStatus.Maybe: {
        this.dialogControl.feedbackDialog.visible = true;
        break;
      }
      case CalendarEventFeedbackStatus.Negative: {
        this.dialogControl.feedbackDialog.visible = true;
        break;
      }
    }
  }

  onSendFeedback(): void {
    this.dialogControl.feedbackDialog.visible = false;
    const request: CalendarEventFeedbackInput = { status: this.dialogControl.feedbackDialog.status, comment: this.dialogControl.feedbackDialog.comment }
    this.apolloClient.mutate<Mutation>({
      mutation: this.MUTATION_SEND_FEEDBACK,
      variables: {
        eventId: this.dialogControl.feedbackDialog.event.id, feedback:request
      }
    }).subscribe((result)=>{
        const event = this.dialogControl.feedbackDialog.event as CalendarEvent;
        event.ownFeedback = result.data.createEventFeedback;
        this.eventsToGiveFeedback = this.eventsToGiveFeedback.filter(e=>e.id !== event.id);
    })
  }

      onModalShow(modal: string){
        let elem = document.getElementById(modal).querySelectorAll(".p-dialog-close-button").item(0) as HTMLElement;
        elem.focus();
    }

    getViewButtonStyle(){
        if(this.calendarViewActive){
            if(this.eventsToGiveFeedback.length == 0){
                return this.whiteButtonLastActive;
            }
            return this.whiteButtonActive;
        }
        else{
            if(this.eventsToGiveFeedback.length == 0){
                return this.whiteButtonLast;
            }
            return this.whiteButton;
        }
    }

    isFavorite(event: CalendarEvent): boolean{
      return this.favoritesArray.includes(event.id);
    }

    onToggleFavorite(appointment: CalendarEvent): void{
      if(this.isFavorite(appointment)){
        this.favoritesArray.splice(this.favoritesArray.indexOf(appointment.id), 1);
      }
      else{
          this.favoritesArray.push(appointment.id);
      }
      localStorage.setItem(`state_${this.component}_favorites`, JSON.stringify(this.favoritesArray));
    }

    protected readonly appointmentCard = appointmentCard;
}
